export const green = {
  50: '#0F2628',
  100: '#0E3633',
  200: '#0A5749',
  300: '#07775E',
  400: '#039874',
  500: '#00B88A',
  600: '#33C6A1',
  700: '#66D4B9',
  800: '#99E3D0',
  850: '#B2EADC',
  900: '#CCF1E8',
  950: '#E5F8F3',
  975: '#F2FBF9',
  990: '#FAFEFD',
} as const;
